import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateOrganization(
    $id: String!
    $data: updateOrganizationInput!
  ) {
    updateOrganization(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateOrganizationInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/update_organization',
  async (
  params: {id: String;data: TYPES.UpdateOrganizationInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateOrganizationSlice = createSlice({
  name: 'update_organization',
  initialState: initialState,
  reducers: {
    updateOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateOrganizationClear } = updateOrganizationSlice.actions;

export const updateOrganization = createSelector(
  (state: RootState) => state.organization.updateOrganization.result,
  (state: RootState) => state.organization.updateOrganization.error,
  (state: RootState) => state.organization.updateOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateOrganizationSlice.reducer;